import { BaseRequestModel } from '../../../base/base.request.model';

export class RecordPlayTimeRequestModel extends BaseRequestModel {
  assetId?: string;
}
